import React from 'react';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css'

const InfoTooltip = ({ text = '' }) => {
  return (
    <Tooltip
      // options
      title={text}
      open={true}
    >
      <p>
        <span className="glyphicon glyphicon-info-sign"/>
      </p>
    </Tooltip>
  )
}

export default InfoTooltip;
